import API from '../http'
import {IsManagerPro} from '@/utils'

/**
 *
 * 应用列表
 * @param params
 * @returns
 */
export const AppList = (params: any) => {
  return API.POST('/itg/appInfo/client', params)
}

/**
 *
 * 应用添加
 * @param params
 * @returns
 */
export const AppSave = (params: any) => {
  if (IsManagerPro) {
    return API.POST(`/itg/admin/corp/config/save/${params.corpId}`, params)
  }
  return API.POST('/itg/appInfo/client/config/save', params)
}

/**
 *
 * 应用删除
 * @param params
 * @returns
 */
export const AppDelete = (params: any) => {
  return API.DELETE(`/itg/appInfo/client/status/${params.id}`, params)
}
